const areEnabled = (state: AnyFixMe) => state.mobile.introsEnabled;

export { areEnabled };
